import { DestinationPlaceholder } from "@/routes/DestinationPlaceholder";

export function BillsCompliance() {
  return <DestinationPlaceholder id="bills-compliance" />;
}
